import React from 'react';

/**
 * onClick & href ?
 * @param onClickEpoLogo
 */
function Logo({ onClickEpoLogo, targetUrl, srcPath }: any) {
    const onClick = (event: MouseEvent) => {
        if (onClickEpoLogo) {
            onClickEpoLogo(event);
        }
    };

    return (
        <a
            href={targetUrl}
            target="_blank"
            rel="noopener noreferrer"
            title={targetUrl}
            aria-label={targetUrl}
            onClick={(event: any) => onClick(event)}
        >
            <img src={srcPath} alt="Logo of the European Patent Office" width={125} height={60} />
        </a>
    );
};

export default Logo;